<template>
    <div>
        <b-modal :active.sync="showDifferenceModal" id="differenceModal" aria-modal :width="1200" @close="changes = {}">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head"><p class="modal-card-title">Wijzigingen</p></header>
                <section class="modal-card-body" style="overflow: hidden;padding: 5px;">
                    <table class="table is-fullwidth" v-if="changes && _.has(changes, 'attributes')">
                        <thead>
                            <tr>
                                <th>Kolom</th>
                                <th>Oud</th>
                                <th>Nieuw</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(change, index) in changes.attributes" :key="'change_'+index">
                                <td width="125">
                                    {{ index }}
                                </td>
                                <td style="background-color:#fdd5d5;word-break:break-word;">
                                    <span v-if="_.has(changes, 'old')">
                                        <span v-if="index == 'created_at' || index == 'updated_at'">
                                            {{ changes.old[index]|humanDate }}
                                        </span>
                                        <span v-else>
                                            {{ changes.old[index] }}
                                        </span>
                                    </span>
                                    <span v-else>-</span>
                                </td>
                                <td style="background-color:#d8ead8;word-break:break-word;">
                                    <span v-if="index == 'created_at' || index == 'updated_at'">
                                        {{ change|humanDate }}
                                    </span>
                                    <span v-else>
                                        {{ change }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else>
                        <h4>Geen wijzigingen gevonden!</h4>
                    </div>
                </section>
            </div>
        </b-modal>

        <div v-if="showFilters && (this.filters && Object.keys(this.filters).length)">
            <h3>Filters:</h3>

            <div class="buttons">
                <b-button
                    v-for="(filter, index) in filters"
                    icon-right="trash-alt"
                    type="is-danger"
                    :key="'filter_'+index"
                    @click="removeFilter(index)"
                >{{ filter.name }}</b-button>
            </div>
            <hr>
        </div>

        <b-table
            :data="records"
            :striped="true"
            :loading="loading"
            :mobile-cards="true"

            backend-pagination
            :total="total"
            :per-page="perPage"
            @page-change="onPageChange"
            backend-sorting
            :default-sort-direction="sortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort"

            :paginated="paginated"
            :sort-icon="'chevron-up'"
        >
            <template>
                <b-table-column v-slot="props" field="subject_type" label="Type" sortable>
                    {{ subjectName(props.row.subject_type) }}
                </b-table-column>

                <b-table-column v-slot="props" field=" " :visible="user.role == 'pit' && showAdminTab" sortable>
                    <span v-if="subjectName(props.row.subject_type) == 'Organisatie'">
                        <b-button
                            type="is-primary"
                            size="is-small"
                            v-if="organisations && organisations[props.row.subject_id]"
                            @click="appendFilter({'name': 'Organisatie: '+organisations[props.row.subject_id].name, 'query': {subject_type: 'App\\Organisation', subject_id: props.row.subject_id}})"
                        >{{ organisations[props.row.subject_id].name }}</b-button>
                        <span v-else><i>(verwijderd)</i></span>
                    </span>
                    <span v-if="subjectName(props.row.subject_type) == 'Box'">
                        <b-button
                            type="is-primary"
                            size="is-small"
                            @click="appendFilter({'name': 'Box (ID: '+props.row.subject_id+')', 'query': {subject_type: 'App\\Box', subject_id: props.row.subject_id}})"
                        >{{ `ID: ${props.row.subject_id}` }}</b-button>
                    </span>

                </b-table-column>

                <b-table-column v-slot="props" field="description" label="Gebeurtenis" sortable>
                    {{ subjectDescription(props.row.description) }}
                </b-table-column>

                <b-table-column v-slot="props" field="user.name" label="Door wie" sortable>
                    <span v-if="props.row.user">{{ props.row.user.name }}{{ props.row.user.role == 'pit' ? ' (PIT)' : ' ('+props.row.user.organisation.name+')' }}</span>
                </b-table-column>

                <b-table-column v-slot="props" field="created_at" label="Wanneer" width="180" sortable>
                    {{ props.row.created_at|humanDateTime }}
                </b-table-column>

                <b-table-column v-slot="props" field="properties" label="Aanpassing" numeric>
                    <b-button
                        type="is-dark"
                        size="is-small"
                        v-if="props.row.properties && Object.keys(props.row.properties).length"
                        @click="showChanges(props.row.properties)"
                    >{{ props.row.description == 'updated' ? 'Bekijk aanpassingen' : props.row.description == 'created' ? 'Bekijk toevoeging' : props.row.description == 'deleted' ? 'Verwijderd' : props.row.description }}</b-button>
                    <span v-else>-</span>
                </b-table-column>
            </template>

            <template #empty>
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p class="margin0" v-if="loading === false">
                            <div v-if="inError">
                                <p>Logs konden niet opgehaald worden, probeer het opnieuw.</p>
                                <b-button type="is-primary" @click="loadAsyncData()">Probeer opnieuw</b-button>
                            </div>
                            <div v-else>
                                <p>Geen logs gevonden.</p>
                            </div>
                        </p>
                        <p class="margin0" v-if="loading">Laden...</p>
                    </div>
                </section>
            </template>
        </b-table>
    </div>
</template>

<script>
import Vue from 'vue'
import qs from 'querystringify'
import filtersMixin from '@/mixins/filterMixins'
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'LogsRecord',
    mixins: [filtersMixin, paramsMixin],

    props: {
        searchParamName: {
            type: String,
            default: null
        },
        getFilters: {
            type: Object,
            required: false
        },
        showFilters: {
            type: Boolean,
            default: false
        },
        passLogs: {
            type: [Object, Boolean],
            default: false
        },
        showAdminTab: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            searchParams: typeof(this.$store.state.searchQueries[this.searchParamName]) != 'undefined' ? this.$store.state.searchQueries[this.searchParamName] : null,
            records: [],
            total: null,
            loading: false,
            sortField: 'created_at',
            sortOrder: 'desc',
            defaultSortOrder: 'desc',
            page: 1,
            perPage: 35,
            changes: {},
            filters: null,
            showDifferenceModal: false,
            inError: false
        }
    },

    computed: {
        paginated(){
            return this.records && this.records.length < this.total
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        }
    },

    created() {
        // Set filters if we received any.
        if(this.getFilters){
            Vue.set(this, 'filters', this.getFilters)
        }
    },

    methods: {
        load: _.debounce(function(elem = this){
            // Check if in this session a query is saved (last success) else use default sorting.
            elem.getSearchParams().then(() => {
                elem.loadAsyncData()
            })
        }, 100),

        loadAsyncData() {
            // Set filter params & admin params
            const params = this.setParams(this.searchParams, this.searchParamName)

            this.loading = true
            this.$emit('passLoading', true)

            // Filters
            let filters = []
            let allQueries = []

            if(this.filters){
                _.forEach(this.filters, (filterObj, key) => {
                    if(typeof(filters[key] == 'undefined')){
                        filters[key] = {}
                    }
                    _.forEach(filterObj.query, (value, index) => {
                        filters[key][index] = value
                    })

                    allQueries.push(`filters[`+key+']='+[qs.stringify(filters[key], { addQueryPrefix: false, delimiter: '|' }).substr(1).replace('&', '|')])
                })
            }

            axios.get(`/api/logs?${params}${allQueries.length ? '&'+allQueries : ''}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = []

                this.total = response.data.total
                this.page = response.data.current_page
                this.records = response.data.data

                this.$store.dispatch('setSearchQuery', {type: this.searchParamName, query: params})
                this.inError = false
            }).catch((error) => {
                console.error('[❌] Error while fetching logs:', error)
                this.data = []
                this.total = null
                this.inError = true
            }).then(() => {
                this.loading = false
                this.searchParams = null

                this.$emit('passTotal', this.total)
                this.$emit('passLoading', false)
            })
        },

        // Add a new filter to the filters object
        appendFilter(obj) {
            // if(_.find(this.filters, ['name', obj.name])){
            //     this.$buefy.toast.open({
            //         duration: 2000,
            //         message: `Filter '${obj.name}' is al actief!`,
            //         type: 'is-danger'
            //     }); return false;
            // }

            Vue.set(this, 'filters', {
                ...this.filters,
                [this.filters ? Object.keys(this.filters).length : 0]: {
                    ...obj
                }
            })

            this.load()
        },
        // Remove filter from the filters object
        removeFilter(index){
            let theFilters = {...this.filters}
            delete theFilters[index]

            Vue.set(this, 'filters', theFilters)

            this.load()
        },

        showChanges(objects){
            this.changes = objects
            this.showDifferenceModal = true
        },

        // Filters
        subjectName(model){
            let modelName = model ? model.replace('App\\', '').toLowerCase() : '-'

            switch(modelName){
                case 'organisation':
                    return 'Organisatie'
                case 'box':
                    return 'Box'
                case 'communication':
                    return 'Communicatie'
                case 'user':
                    return 'Gebruiker'
                case 'product':
                    return 'Product'
                case 'maillog':
                    return 'Mail verzonden'
                case 'contract':
                    return 'Contract'
                case 'contractproduct':
                    return 'Contract product'
                case 'invoice':
                    return 'Factuur'
                case 'invoiceproduct':
                    return 'Factuur product'
                case 'contracttemplate':
                    return 'Contract sjabloon'
                case 'invoicepayment':
                    return 'Betaling'
                case 'cronjob':
                    return 'Automatisering'
                case 'paynl':
                    return 'Pay.nl instelling'
                case 'customer':
                    return 'Klant'
                case 'access':
                    return 'Toegang'
                case 'massmail':
                    return 'Massa mail'
                case 'contractfile':
                    return 'Contract bestand'
                case 'onlinerental':
                    return 'Online verhuur'
                case 'contractfilesign':
                    return 'Contract bestand ondertekening'
                case 'userorganisation':
                    return 'Gebruiker organisatie'
                default:
                    return model
            }
        },
        subjectDescription(description){
            switch(description){
                case 'updated':
                    return 'Wijziging'
                case 'created':
                    return 'Nieuw'
                case 'deleted':
                    return 'Verwijderd'
                default:
                    return description
            }
        },

        // Table/paginate actions
        onPageChange(page) {
            this.page = page
            this.load()
        },
        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.load()
        },
    },

    watch: {
        getFilters: {
            handler: function(newVal, oldVal) {
                if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
                    Vue.set(this, 'filters', this.getFilters)

                    this.load()
                }
            }, deep: true
        }
    }
}
</script>